import { Type } from "lucide-react";

/**
 * Subtle info card reminding users that text is edited inline on the canvas.
 */
export function TextHintCard() {
  return (
    <div className="flex gap-2.5 bg-paper rounded-[10px] px-3 py-2.5 text-[12px] leading-relaxed text-ink-4 mb-[18px]">
      <Type
        size={14}
        strokeWidth={2}
        className="flex-none mt-0.5 text-tide"
      />
      <span>
        <b>Text is edited on the page.</b> Click any heading, paragraph, or
        button label in the preview and type. In body and subheading text,
        Enter starts a new paragraph and Shift+Enter makes a tight line break.
      </span>
    </div>
  );
}
